import classNames from "classnames";
import { useTranslation } from "react-i18next";

interface Props {
  name: string;
  onToggle?: () => void;
}

const PILL_CLASSES =
  "mx-1 inline-flex max-w-full flex-wrap items-center rounded border border-purple-200 bg-purple-50 px-1.5 py-1 align-middle text-sm font-medium text-purple-900";

const MessageDirectivePill = ({ name, onToggle }: Props) => {
  const { t } = useTranslation();
  const testId = `duck-message-directive-pill-${name}`;

  if (!onToggle) {
    return (
      <span className={PILL_CLASSES} data-testid={testId}>
        /{name}
      </span>
    );
  }

  return (
    <button
      aria-label={t("duck:directive_expand", { name })}
      className={classNames(PILL_CLASSES, "hover:bg-purple-100")}
      data-testid={testId}
      type="button"
      onClick={onToggle}
    >
      /{name}
    </button>
  );
};

export default MessageDirectivePill;
